// extracted by mini-css-extract-plugin
export default {"li":"nav_logo___li___f9bf3883","link":"nav_logo___link___b42685fe","squareLogo":"nav_logo___squareLogo___c906bc33"};